import { Injectable, inject } from "@angular/core";
import { Subject, Observable, merge, timer, switchMap, retry, tap, shareReplay } from "rxjs";
import { IObjectStatus, IObjectStatusParsed } from "../object-history-common.models";
import { ObjectStatusService } from "./object-status-service";
import { ICoordinatesViewModel } from "app/system/mobile-models/profile-models";
import { BaseProfileService } from "./base-profile-service";
import { IProfileModelMap, IProfileModel, Object, IShift, IMapLayer, IGeozone, IIcon, ITrendIcon, IDriverGroup, IReportTemplate, ICommandTemplate, IGeozoneGroup, IDriver, IDriverKeyGroup, IObjectGroup, IDriverPenalty, ISensor, IDriverKey, IGeozoneParsed, ObjectParsed } from "app/system/mobile-models/profile-models";
@Injectable({ providedIn: 'root' })
export class ProfileStoreService {

  private readonly KEY_CENTER = 'map:lastCenter';
  private readonly KEY_ZOOM = 'map:lastZoom';
  private readonly KEY_OBJECT_ID_SELECTED = 'monitoring:selectedObject';
  private readonly MAP_TITLES_KEY = 'Map#titles';
  private readonly MAP_GEOZONE_TITLES_KEY = 'Map#geozone_titles';
  // ---------------------------
  // MAP STATE MANAGEMENT
  // ---------------------------

  public readMapCenter(
    defaultCenter: ICoordinatesViewModel = { latitude: 55.7569, longitude: 37.6151 }
  ): ICoordinatesViewModel {
    try {
      const raw = localStorage.getItem(this.KEY_CENTER);
      return raw ? JSON.parse(raw) as ICoordinatesViewModel : defaultCenter;
    } catch {
      return defaultCenter;
    }
  }

  public readMapZoom(defaultZoom = 12): number {
    try {
      const raw = localStorage.getItem(this.KEY_ZOOM);
      return raw ? JSON.parse(raw) as number : defaultZoom;
    } catch {
      return defaultZoom;
    }
  }

  public saveMapCenter(center: ICoordinatesViewModel): void {
    try {
      localStorage.setItem(this.KEY_CENTER, JSON.stringify(center));
    } catch { }
  }

  public saveMapZoom(zoom: number): void {
    try {
      localStorage.setItem(this.KEY_ZOOM, JSON.stringify(zoom));
    } catch { }
  }

  // ---------------------------
  // OBJECT ID STATE MANAGEMENT
  // ---------------------------

  public readSelectedObjectId(profileObjects?: Object[]): number | null {
    try {

      const savedId = localStorage.getItem(this.KEY_OBJECT_ID_SELECTED);
      let objectId: number | null = savedId ? Number(savedId) : null;

      if (!objectId || isNaN(objectId)) {
        const firstValidObject = profileObjects.find(
          o => o.defLat !== 0 && o.defLng !== 0
        );

        if (firstValidObject) {
          objectId = firstValidObject.id;
          this.saveSelectedObjectId(objectId);
        }
        else {
          objectId = profileObjects.length > 0 ? profileObjects[0].id : null;
        }
      }
      return objectId;
    } catch {
      return null;
    }
  }

  public saveSelectedObjectId(objectId: number): void {
    try {
      if (objectId != 0)
        localStorage.setItem(this.KEY_OBJECT_ID_SELECTED, objectId.toString());
    } catch { }
  }

  public clearSelectedObjectId(): void {
    try {
      localStorage.removeItem(this.KEY_OBJECT_ID_SELECTED);
    } catch { }
  }

  private readBoolean(key: string): boolean {
    return JSON.parse(localStorage.getItem(key) ?? 'false');
  }

  private setBoolean(key: string, value: boolean): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  public readMapShowObjectNames(): boolean {
    return this.readBoolean(this.MAP_TITLES_KEY);
  }

  public readMapShowGeozoneNames(): boolean {
    return this.readBoolean(this.MAP_GEOZONE_TITLES_KEY);
  }

  public setMapShowObjectNames(value: boolean): void {
    this.setBoolean(this.MAP_TITLES_KEY, value);
  }

  public setMapShowGeozoneNames(value: boolean): void {
    this.setBoolean(this.MAP_GEOZONE_TITLES_KEY, value);
  }

}